import { render, staticRenderFns } from "./upLoad2.vue?vue&type=template&id=13583377&scoped=true&"
import script from "./upLoad2.vue?vue&type=script&lang=js&"
export * from "./upLoad2.vue?vue&type=script&lang=js&"
import style0 from "./upLoad2.vue?vue&type=style&index=0&id=13583377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13583377",
  null
  
)

export default component.exports